import React, { useState, useEffect, FC } from 'react'
import Form, { FormComponentProps } from 'antd/lib/form'
import { message, Button, Select } from 'antd'
import { User, UserFormValues, ServiceProvider } from '../../types'
import { serviceProviderService } from '../../services'
import styles from './index.module.less'

interface UserFormProps extends FormComponentProps {
	user?: User
	submit(values: UserFormValues): Promise<void>
}

const UserForm: FC<UserFormProps> = props => {
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [serviceProviders, setServiceProviders] = useState<ServiceProvider[]>([])

	const onSubmit = (): void => {
		setIsLoading(true)
		props.form.validateFields(
			async (errors, values): Promise<void> => {
				if (errors) {
					setIsLoading(false)
					message.error(errors)
					return
				}
				await props.submit(values)
				setIsLoading(false)
			}
		)
	}

	useEffect(() => {
		const getAndSetOrganization = async (): Promise<void> => {
			const { data } = await serviceProviderService.getAll()
			setServiceProviders(data)
		}

		getAndSetOrganization()
	}, [])

	return (
		<Form className={styles.form} hideRequiredMark layout='horizontal' labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} labelAlign='left'>
			<Form.Item label='Service Provider(s)'>
				{props.form.getFieldDecorator('service_provider_ids', {
					initialValue: props.user.organizations.map(i => i.id),
					rules: [
						{
							required: true,
							message: 'At least one Service Provider is required'
						}
					]
				})(
					<Select placeholder='Select a service provider' mode="multiple">
						{serviceProviders.map(sp => (
							<Select.Option value={sp.id} key={sp.id}>
								{sp.name}
							</Select.Option>
						))}
					</Select>
				)}
			</Form.Item>
			<div className={styles.submitButton}>
				<Button type='primary' onClick={onSubmit}>
					{isLoading ? 'Saving' : 'Save'}
				</Button>
			</div>
		</Form>
	)
}

export default Form.create<UserFormProps>()(UserForm)
